<template>
    <div v-if="act">
        <b-row>
            <b-col><b-breadcrumb :items="items"/></b-col>
        </b-row>
        <b-row>
            <b-col cols="8">
                <header>
                    <h2>{{act.title.rendered}}</h2>
                    <p>Ogłoszony {{act.date.replace('T', ' ')}}</p>
                </header>
                <section>
                    <h2>Pliki do pobrania</h2>
                    <ul>
                        <li><a :href="act.post_meta.dziennik_new_pdf" :title="`Plik PDF: ${act.title.rendered}`">
                        {{act.post_meta.dziennik_new_pdf_title ? act.post_meta.dziennik_new_pdf_title :pdfName(act.post_meta.dziennik_new_pdf)}}
                        </a></li>
                    </ul>
                </section>

            </b-col>
            <b-col cols="4">
                <section class="meta">

                    <b-card no-body header="Szczegóły">
                        <b-list-group flush>
                            <b-list-group-item>Rok: {{act.year}}</b-list-group-item>
                            <b-list-group-item>Pozycja: {{act.post_meta.dziennik_position}}</b-list-group-item>
                            <b-list-group-item>Data opublikowania: {{parseDate(act.date)}}</b-list-group-item>
                            <b-list-group-item>Data wydania: {{act.post_meta.dziennik_date_release}}</b-list-group-item>
                            <b-list-group-item>Data podpisania: {{act.post_meta.dziennik_date_sign}}</b-list-group-item>
                            <b-list-group-item>Typ: {{act.post_meta.dziennik_doc_type}}</b-list-group-item>
                        </b-list-group>
                    </b-card>

                </section>

                <section class="visa meta">

                    <b-card no-body header="Wiza" v-if="act.post_meta.dziennik_visa_person_name">
                        <b-list-group flush>

                            <b-list-group-item>Imię i nazwisko: {{act.post_meta.dziennik_visa_person_name}}</b-list-group-item>
                            <b-list-group-item>Stanowisko służbowe: {{act.post_meta.dziennik_visa_person_jobname}}</b-list-group-item>
                            <b-list-group-item>Data nadania wizy: {{act.post_meta.dziennik_visa_person_date}}</b-list-group-item>
                            <b-list-group-item>
                                XADES:
                                <a :href="act.post_meta.dziennik_new_xades">XADES</a>
                            </b-list-group-item>
                            <b-list-group-item>
                                XML:
                                <a :href="act.post_meta.dziennik_new_xml">XML</a>
                            </b-list-group-item>
                            <b-list-group-item>
                                ZIP:
                                <a :href="act.post_meta.dziennik_new_zip">ZIP</a>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>

                </section>


            </b-col>
        </b-row>
    </div>

  <div class="alert alert-info text-center" role="status" v-else>
    <h1>Wczytuje...</h1>
  </div>
</template>

<script>
    import app from '../store/store2'

    export default {
        name: 'ActsSingle',
        props: ['id'],
        data () {
            return {
                items: [
                    { text: 'Dzienniki', href: '#/acts' },
                ],
                act: '',
            }
        },
        created () {
            var self = this;
            this.$http.get( app.actsurl + this.id )
            .then(
                function( res ) {
                    //console.log( res.data );
                    self.act = res.data
                  console.log(self.act);
                }

            )
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                //console.log( 'start' );
                self.breadcrumbPush( self.act );
            });


        },
        methods: {
            parseDate(date) {
                return date.substr(0, 10 );
            },
            breadcrumbPush: function( act ) {
                this.items.push({ text: act.post_meta.dziennik_short_title, href: '#' });
            },
          pdfName(fullName){
            let pieces = fullName.split(/[/,]+/);
            return pieces[pieces.length-1];
          }
        }
    }
</script>

<style scoped>
    header  {
        border-bottom: 1px solid #EEE;
        margin-bottom: 1em;
    }
    header h2 {
        font-size: 1.4rem;
    }

    header p {
        color: #515151;
    }

    section h2 {
        font-weight: 700;
        font-size: 1.2rem;
    }

    section.meta .card-header {
        background-color: #10457d;
        color: #FFF;
    }
    section.meta .list-group{
      color: #515151;
    }
</style>

<style>
    .VueTables__child-row {

    }

    .table-hover tbody tr.table-hover tbody tr.VueTables__child-row-toggler:hover {
        background-color: none;
    }

    .VueTables__child-row-toggler {
        border: 1px solid #EEE;
        display: inline-block;
        width: 20px;
        height: 20px;
        background-color: #FFF;
    }

    .meta .list-group {
        color: #888;
        font-size: 14px;
    }

    .glyphicon.spinning {
      animation: spin 1s infinite linear;
      -webkit-animation: spin2 1s infinite linear;
    }

    @keyframes spin {
      from { transform: scale(1) rotate(0deg); }
      to { transform: scale(1) rotate(360deg); }
    }

    @-webkit-keyframes spin2 {
      from { -webkit-transform: rotate(0deg); }
      to { -webkit-transform: rotate(360deg); }
    }
</style>



// WEBPACK FOOTER //
// src/components/acts_single.vue